import * as React from "react";
import type { SVGProps } from "react";
export const SvgBrandsGoogle = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="#4285F4"
      d="M12 10.181v3.873h5.382a4.61 4.61 0 0 1-2.01 3.01l3.246 2.517c1.891-1.745 2.982-4.309 2.982-7.354 0-.71-.064-1.391-.182-2.046H12Z"
    />
    <path
      fill="#34A853"
      d="m6.396 13.903-.732.56-2.591 2.019C4.718 19.745 8.09 22 12 22c2.7 0 4.963-.89 6.618-2.418l-3.246-2.518c-.89.6-2.027.963-3.372.963-2.6 0-4.81-1.754-5.6-4.118l-.004-.006Z"
    />
    <path
      fill="#FBBC05"
      d="M3.073 7.518A9.877 9.877 0 0 0 2 12c0 1.618.39 3.136 1.073 4.482C3.073 16.49 6.4 13.9 6.4 13.9c-.2-.6-.318-1.236-.318-1.9 0-.664.118-1.3.318-1.9L3.073 7.518Z"
    />
    <path
      fill="#EA4335"
      d="M12 5.982c1.473 0 2.782.509 3.827 1.49l2.864-2.863C16.954 2.991 14.7 2 12 2 8.09 2 4.718 4.245 3.073 7.518L6.4 10.1c.79-2.364 3-4.118 5.6-4.118Z"
    />
  </svg>
);
